var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.186 0.205601C13.4601 -0.0685336 13.9045 -0.0685336 14.1787 0.205601L19.7944 5.82132C20.0685 6.09545 20.0685 6.53991 19.7944 6.81404L17.124 9.48442L15.9609 14.1368C15.7808 14.8573 15.2344 15.4297 14.523 15.6431L0 20L4.35691 5.47695C4.57033 4.76556 5.1427 4.21919 5.86324 4.03906L10.5156 2.87597L13.186 0.205601ZM10.6591 4.28722L6.20374 5.40107C5.96356 5.46112 5.77277 5.64324 5.70163 5.88037L2.09392 17.9061L14.1196 14.2984C14.3568 14.2272 14.5389 14.0364 14.5989 13.7963L15.7128 9.34087L10.6591 4.28722Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21497 17.8698L9.4706 11.9334C10.246 11.9334 10.8745 11.3048 10.8745 10.5295C10.8745 9.7541 10.246 9.12554 9.4706 9.12554C8.69523 9.12554 8.06667 9.7541 8.06667 10.5295L2.13022 17.785L2.09392 17.9061L2.21497 17.8698Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomization);
export default __webpack_public_path__ + "static/media/customization.37f0fff61a71981dca5d81cb1435acf0.svg";
export { ForwardRef as ReactComponent };